import React, { useMemo, useState } from 'react';
import { FiX } from 'react-icons/fi';
import '../ProductModal/ProductModal.css';

const REASONS = [
  { id: 'spam', label: 'Spam' },
  { id: 'harassment', label: 'Acoso' },
  { id: 'hate', label: 'Odio' },
  { id: 'nudity', label: 'Desnudez' },
  { id: 'violence', label: 'Violencia' },
  { id: 'misinformation', label: 'Información falsa' },
  { id: 'other', label: 'Otro' }
];

const ReportModal = ({ open, onClose, onSubmit }) => {
  const [reason, setReason] = useState('spam');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const controlStyle = useMemo(
    () => ({
      width: '100%',
      padding: '0.6rem 0.75rem',
      borderRadius: 'var(--radius-md)',
      border: '1px solid var(--border)',
      background: 'var(--surface)',
      color: 'var(--text-primary)',
      outline: 'none'
    }),
    []
  );

  if (!open) return null;

  return (
    <div className="product-modal-overlay" onClick={onClose}>
      <div
        className="product-modal"
        style={{ width: 'min(560px, 100%)' }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="product-modal-close" onClick={onClose} aria-label="Cerrar">
          <FiX />
        </button>

        <div className="product-modal-content">
          <h3 className="product-modal-title" style={{ fontSize: '1.25rem' }}>
            Reportar
          </h3>
          <p className="product-modal-description">
            Selecciona un motivo y, si quieres, agrega una descripción.
          </p>

          <div style={{ display: 'grid', gap: 10 }}>
            <label style={{ display: 'grid', gap: 6 }}>
              <span style={{ color: 'var(--text-secondary)', fontWeight: 600, fontSize: '0.9rem' }}>
                Motivo
              </span>
              <select value={reason} onChange={(e) => setReason(e.target.value)} style={controlStyle}>
                {REASONS.map((r) => (
                  <option key={r.id} value={r.id}>
                    {r.label}
                  </option>
                ))}
              </select>
            </label>

            <label style={{ display: 'grid', gap: 6 }}>
              <span style={{ color: 'var(--text-secondary)', fontWeight: 600, fontSize: '0.9rem' }}>
                Descripción (opcional)
              </span>
              <textarea
                rows={4}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Describe el problema…"
                style={{ ...controlStyle, resize: 'vertical' }}
              />
            </label>

            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button type="button" className="btn btn-ghost" onClick={onClose} disabled={submitting}>
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-primary"
                disabled={submitting}
                onClick={async () => {
                  if (!onSubmit) return;
                  setSubmitting(true);
                  try {
                    await onSubmit({ reason, description: description.trim() ? description.trim() : null });
                    setDescription('');
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                {submitting ? 'Enviando…' : 'Enviar'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportModal;
